/* ================================================
   POKÉVAULT — JAVASCRIPT v2.0
   Search live · Cart AJAX · UX animations
   ================================================ */

(function () {
  'use strict';

  /* ================================================
     SEARCH — toggle + live suggestions
     ================================================ */
  var searchBar    = document.getElementById('searchBar');
  var searchInput  = document.getElementById('searchInput');
  var suggestions  = document.getElementById('searchSuggestions');
  var searchOpen   = false;
  var searchTimer  = null;

  window.toggleSearch = function () {
    searchOpen = !searchOpen;
    if (searchBar) {
      searchBar.classList.toggle('open', searchOpen);
      searchBar.setAttribute('aria-hidden', String(!searchOpen));
      if (searchOpen && searchInput) {
        setTimeout(function () { searchInput.focus(); }, 350);
      } else {
        hideSuggestions();
      }
    }
  };

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = this.value.trim();
      if (q.length < 2) { hideSuggestions(); return; }
      searchTimer = setTimeout(function () { fetchSuggestions(q); }, 280);
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') toggleSearch();
    });
  }

  function fetchSuggestions(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.resources && data.resources.results && data.resources.results.products;
        if (!products || products.length === 0) { hideSuggestions(); return; }
        renderSuggestions(products);
      })
      .catch(function () { hideSuggestions(); });
  }

  function renderSuggestions(products) {
    if (!suggestions) return;
    suggestions.innerHTML = products.map(function (p) {
      var img = p.featured_image && p.featured_image.url
        ? '<img src="' + p.featured_image.url + '" alt="' + escHtml(p.title) + '" loading="lazy">'
        : '<span style="font-size:1.6rem;width:40px;text-align:center">🎴</span>';
      var price = p.price ? formatMoney(p.price) : '';
      return '<a href="' + p.url + '" class="suggestion-item">'
        + img
        + '<span>' + escHtml(p.title) + '</span>'
        + (price ? '<span class="sug-price">' + price + '</span>' : '')
        + '</a>';
    }).join('');
    suggestions.style.display = 'block';
  }

  function hideSuggestions() {
    if (suggestions) { suggestions.innerHTML = ''; suggestions.style.display = 'none'; }
  }

  // Close suggestions on outside click
  document.addEventListener('click', function (e) {
    if (searchBar && !searchBar.contains(e.target)) hideSuggestions();
  });

  /* ================================================
     MOBILE MENU
     ================================================ */
  var mobileMenu = document.getElementById('mobileMenu');
  var menuOpen   = false;

  window.toggleMenu = function () {
    menuOpen = !menuOpen;
    if (mobileMenu) {
      mobileMenu.classList.toggle('open', menuOpen);
      mobileMenu.setAttribute('aria-hidden', String(!menuOpen));
    }
  };

  /* ================================================
     AJAX ADD TO CART
     ================================================ */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('card-atc-form') && !form.classList.contains('product-form')) return;
    // Skip cart change/remove forms
    var action = form.getAttribute('action') || '';
    if (action.includes('/cart/change') || action.includes('/cart/remove')) return;

    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var originalHTML = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = '✓'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        showToast('❌ ' + (data.description || 'Erreur'));
      } else {
        refreshCartCount();
        showToast('🛒 ' + (data.title || 'Produit') + ' ajouté !');
      }
    })
    .catch(function () { showToast('❌ Erreur, réessaie !'); })
    .finally(function () {
      if (btn) {
        setTimeout(function () { btn.innerHTML = originalHTML; btn.disabled = false; }, 1600);
      }
    });
  });

  /* ================================================
     CART COUNT REFRESH
     ================================================ */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('cart-count');
        if (el) {
          el.textContent = cart.item_count;
          el.classList.add('bump');
          setTimeout(function () { el.classList.remove('bump'); }, 500);
        }
      });
  }

  /* ================================================
     CART PAGE — update qty via AJAX
     ================================================ */
  window.updateQty = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function () { window.location.reload(); })
    .catch(function () { window.location.reload(); });
  };

  /* ================================================
     TOAST
     ================================================ */
  var toastEl    = null;
  var toastTimer = null;

  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.id = 'pv-toast';
      document.body.appendChild(toastEl);
    }
    clearTimeout(toastTimer);
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2800);
  }

  /* ================================================
     SCROLL REVEAL
     ================================================ */
  if ('IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    function initReveal() {
      document.querySelectorAll('.product-card, .why-card, .pca-step, .pca-offer, .faq-item').forEach(function (el) {
        el.classList.add('reveal');
        revealObs.observe(el);
      });
    }
    initReveal();
  }

  /* ================================================
     GALLERY THUMBS — active state
     ================================================ */
  document.querySelectorAll('.thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ================================================
     SMOOTH SCROLL
     ================================================ */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (menuOpen) toggleMenu();
      }
    });
  });

  /* ================================================
     HELPERS
     ================================================ */
  function escHtml(str) {
    return (str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

})();
